import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-services-page',
    templateUrl: './services-page.component.html',
    styleUrls: ['./services-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicesPageComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'Services'
        }
    ]
    singleSolutionsBox: solutionsBoxContent[] = [
        {
            icon: 'assets/img/services/icon5.png',
            title: 'Web Development',
            paragraphText: 'At Devotory, we provide end-to-end web development services across all major frameworks and technologies, ensuring a tailored approach to meet your unique needs.',
            link: 'services-details/1',
            linkText: 'Read More',
            //linkIcon: 'flaticon-right'
        },
        {
            icon: 'assets/img/services/icon1.png',
            title: 'Dedicated Development Team',
            paragraphText: 'We provide dedicated development teams at competitive hourly rates, giving you access to top-tier talent without the overhead of traditional hiring. Our developers are highly skilled and bring a wealth of experience to your projects.',
            link: 'services-details/2',
            linkText: 'Read More',
        },
        {
            icon: 'assets/img/services/icon2.png',
            title: 'AI & ML Development',
            paragraphText: 'At Devotory, we excel in developing cutting-edge AI applications that drive innovation and deliver impactful results. Our expertise spans a range of AI technologies and methodologies, tailored to meet your specific needs.',           
            link: 'services-details/3',
            linkText: 'Read More',    
        },
        // {
        //     icon: 'flaticon-segmentation',
        //     title: 'Research',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna adipiscing aliqua.',
        //     link: 'services-details',
        //     linkText: 'View Details'
        // },
        // {
        //     icon: 'flaticon-analytics',
        //     title: 'Analytics',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna adipiscing aliqua.',
        //     link: 'services-details',
        //     linkText: 'View Details'
        // },
        // {
        //     icon: 'flaticon-settings',
        //     title: 'Technology',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna adipiscing aliqua.',
        //     link: 'services-details',
        //     linkText: 'View Details'
        // }
    ]

}
class pageTitle {
    title : string;
}
class solutionsBoxContent {
    icon : string;
    title : string;
    paragraphText : string;
    link : string;
    linkText : string;
}